export default __webpack_public_path__ + "static/savings-type-store-7d677e37bbe07403c7636f40e1a471b3.png";